import { create } from "zustand";

type TabsStore = {
  tabValue: number;
  setTabValue: (value: number) => void;
};

export const useTabsPreparation = create<TabsStore>((set) => ({
  tabValue: 0,
  setTabValue: (value: number) => set({ tabValue: value }),
}));

